import React, { Component } from 'react';
import { Table } from 'semantic-ui-react';
import PartForm from './PartForm';
import { Part } from '../../models/Part';
import { getParent, getSnapshot, applySnapshot, clone } from 'mobx-state-tree'
import { observer } from 'mobx-react';

class PartsList extends Component {

  state = {
    isFormOpen: false,
    selectedPart: null,
    clone: null
  }

  render() { 
    return (
      <div>
        <PartForm 
          isOpen={this.state.isFormOpen}
          isNew={this.state.selectedPart ? false : true} 
          part={this.state.clone} 
          onCancel={this.cancelEdit} 
          onSave={this.commitChanges}
        />
        <Table striped compact='very'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Part</Table.HeaderCell>
              <Table.HeaderCell>Material</Table.HeaderCell>
              <Table.HeaderCell>Qty</Table.HeaderCell>
              <Table.HeaderCell>Cut at</Table.HeaderCell>
              <Table.HeaderCell>Comment</Table.HeaderCell>
              <Table.HeaderCell />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.props.parts.map((part, index) => {
              const dimensions = part.cutLength ? part.cutLength + (part.cutWidth ? ' x ' + part.cutWidth : '') + ' mm' : '';
              return (<Table.Row key={index}>
                <Table.Cell>{part.name}</Table.Cell>
                <Table.Cell>{part.materialDescription}</Table.Cell>
                <Table.Cell>{part.qty * (this.props.qty || 1)}</Table.Cell>
                <Table.Cell>{dimensions}</Table.Cell>
                <Table.Cell>{part.comment}</Table.Cell>
                {!this.props.noEdit &&
                  <Table.Cell>
                    <a href='#edit-part' onClick={() => this.editPart(part)}>Edit</a>
                    &emsp;
                    <a href='#remove-part' onClick={() => this.removePart(part)}>Remove</a>
                  </Table.Cell>
                }
              </Table.Row>)
            })}
            {!this.props.noEdit &&
              <Table.Row>
                <Table.Cell colSpan='6'>
                  <a href='#add-part' onClick={this.addPart}>Add part</a>
                </Table.Cell>
              </Table.Row>
            }
          </Table.Body>
        </Table>
      </div>
    )
  }

  addPart = () => {
    this.setState({
      selectedPart: null,
      clone: Part.create(),
      isFormOpen: true
    })
  }

  editPart = part => {
    this.setState({
      selectedPart: part,
      clone: clone(part),
      isFormOpen: true
    })
  }

  removePart = part => {
    const job = getParent(this.props.parts)
    part.remove()
    job.recalculateMaterialsForAllEstimates()
  }

  cancelEdit = () => {
    this.setState({
      selectedPart: null,
      clone: null,
      isFormOpen: false
    })
  }

  commitChanges = () => {
    const { clone } = this.state;
    const job = getParent(this.props.parts)
    if (this.state.selectedPart) {
      applySnapshot(this.state.selectedPart, getSnapshot(clone))
    } else {
      job.addPart(clone)
    }
    job.recalculateMaterialsForAllEstimates()
    // if (hasParent(job)) job.save()
    this.cancelEdit()
  }

}
 
export default observer(PartsList);


// WEBPACK FOOTER //
// ./src/components/jobs/PartTable.js